import "./styles.css";
import { completeLogin, getUser } from "./auth/auth.js";
import { route, render } from "./router.js";
import { loginView } from "./pages/login.js";
import { filesPage } from "./pages/files.js";
import { quizPage } from "./pages/quiz.js";
import { resultsPage } from "./pages/results.js";

async function boot(): Promise<void> {
  const root = document.getElementById("app");
  if (!root) return;

  try {
    // OAuth Authorization Code + PKCE callback.
    if (location.pathname === "/callback") {
      try {
        await completeLogin();
      } catch {
        /* fall through to the login view */
      }
      history.replaceState({}, "", "/");
    }

    const user = await getUser();
    if (!user) {
      loginView(root);
      return;
    }

    route("/", filesPage);
    route("/files", filesPage);
    route("/quiz", quizPage);
    route("/results", resultsPage);
    await render();
  } catch (err) {
    // Never leave a blank page — show something and log the cause for diagnosis.
    console.error("App failed to start:", err);
    root.innerHTML =
      '<div class="login"><h1>Bright Mind Tech</h1>' +
      "<p>Something went wrong loading the app. Please refresh.</p>" +
      '<button class="btn" onclick="location.reload()">Reload</button></div>';
  }
}

void boot();
